import { createApp } from 'vue'

import DropZone from 'dropzone-vue';
import Vidle from 'v-idle-3';
import DisableDevtool from 'disable-devtool';
// optionally import default styles
import 'dropzone-vue/dist/dropzone-vue.common.css';
import 'jquery/src/jquery.js'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.min.js'


import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import './assets/main.css'

import App from './App.vue'
import router from './router'
import store from './store'

import InfiniteLoading from "v3-infinite-loading";
import { LoadingPlugin } from 'vue-loading-overlay';

import "v3-infinite-loading/lib/style.css";
import 'vue-loading-overlay/dist/css/index.css';
import 'primeicons/primeicons.css';


createApp(App)
.use(store)
.use(DropZone)
.use(Vidle, {})
.use(LoadingPlugin)
.component("infinite-loading", InfiniteLoading)
.component('Datepicker', Datepicker)
.use(router).mount('#app')
